import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Redirect non-primary domains to surprizeladomiciliu.ro
const PRIMARY_DOMAIN = "surprizeladomiciliu.ro";
const hostname = window.location.hostname;

if (
  hostname !== PRIMARY_DOMAIN &&
  hostname !== "localhost" &&
  !hostname.includes("preview") &&
  hostname.endsWith(".lovable.app")
) {
  window.location.replace(
    `https://${PRIMARY_DOMAIN}${window.location.pathname}${window.location.search}${window.location.hash}`
  );
} else {
  createRoot(document.getElementById("root")!).render(<App />);
}
